import { render } from "./WtBulkSubmitOverlay.vue?vue&type=template&id=582d9c80&scoped=true"
import script from "./WtBulkSubmitOverlay.vue?vue&type=script&lang=js"
export * from "./WtBulkSubmitOverlay.vue?vue&type=script&lang=js"

import "./WtBulkSubmitOverlay.vue?vue&type=style&index=0&id=582d9c80&lang=scss"
import "./WtBulkSubmitOverlay.vue?vue&type=style&index=1&id=582d9c80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-582d9c80"

export default script